import React from "react";

export interface DownloadPanelProps {
  archiveUrl: string | null;
  schematicUrl: string | null;
}

const DownloadPanel: React.FC<DownloadPanelProps> = ({ archiveUrl, schematicUrl }) => {
  if (!archiveUrl && !schematicUrl) return null;

  return (
    <div className="download-panel" role="region" aria-label="Download">
      <h2>{archiveUrl ? "Design Complete" : "Files Available"}</h2>

      <div className="download-buttons">
        {schematicUrl && (
          <a
            href={schematicUrl}
            download
            className="download-link download-schematic"
            rel="noopener noreferrer"
          >
            ⬇ Download Schematic (.kicad_sch)
          </a>
        )}
        {archiveUrl && (
          <a
            href={archiveUrl}
            download
            className="download-link download-archive"
            rel="noopener noreferrer"
          >
            ⬇ Download Manufacturing Archive (.zip)
          </a>
        )}
      </div>
    </div>
  );
};

export default DownloadPanel;
